import { UiComponentBootstrapResponseBody } from "@gocardless/api/dashboard/types";

import { ApiClient } from "./api";
import { EventBus } from "./bus";
import { Locale } from "./i18n";
import { Appearance, GoCardlessError } from "./types";

export class Core {
  constructor(
    readonly name: string,
    readonly bus: EventBus,
    readonly api: ApiClient,
    readonly appearance: Appearance | undefined,
    readonly onError: (error: GoCardlessError) => void,
    readonly bootstrapData: Promise<Partial<UiComponentBootstrapResponseBody>>,
    readonly locale: Locale
  ) {}
}
